import {Component, Inject, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {PocketbaseService} from "../../services/pocketbase.service";
import {ENV} from "../../environments/environment.provider";
import {Environment} from "../../environments/ienvironment";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnInit{
  userid: String="";
  avatar: String="";
  isLogin = this.pocket.pb.authStore.isValid;
  constructor(private router: Router, private pocket: PocketbaseService, @Inject(ENV) protected env: Environment) {}

  ngOnInit(): void {
      this.pocket.getUser().then(u=>{
        this.username=u.username
        this.userid = u.id
        this.avatar = u.avatar
    })
  }

  username: String = "";

  logout() {
    this.pocket.pb.authStore.clear();
    this.router.navigate(["/login"])
    location.reload()
  }
}
